const WORK_MANAGEMENT_CLUSTER = {
    mini_site: {
        logo: {
            url: '/work-management',
            alt: 'monday.com work management',
            src: 'https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/minisites/header%20logos/work_management/desktop_open_monday_wm_logo.png',
            mobileSrc: 'https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/minisites/header%20logos/work_management/mobile_monday_wm_logo.png',
        },
        links: [
            {
                url: '/work-management',
                text: 'minisite.header.overview',
            },
            {
                url: '/work-management/marketing',
                text: 'header.tabs.products.mondayMarketer.newLayout.title',
            },
            {
                url: '/work-management/pmo',
                text: 'header.tabs.products.mondayProjects.newLayout.title',
            },
            {
                url: '/work-management/pricing',
                text: 'minisite.header.pricing',
                isPricingPage: 'true',
            },
        ],
        unifiedDesktopLogo: {
            url: '/work-management',
            src: 'https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/minisites/header%20logos/work_management/bigger-desktop_close_monday_wm_logo.png',
            alt: 'monday.com work management',
        },
    },
};

export { WORK_MANAGEMENT_CLUSTER };
